import { render, staticRenderFns } from "./TimeUp.vue?vue&type=template&id=58d6d4f5&scoped=true&"
import script from "./TimeUp.vue?vue&type=script&lang=js&"
export * from "./TimeUp.vue?vue&type=script&lang=js&"
import style0 from "./TimeUp.vue?vue&type=style&index=0&id=58d6d4f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d6d4f5",
  null
  
)

export default component.exports